/* eslint-disable react/jsx-no-target-blank */
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'

const AsideDefault: FC = () => {
  return (
    <>
      <style>{`
        /* ══════════════════════════════════════════
           ASIDE — Modern Sidebar
        ══════════════════════════════════════════ */

        #kt_aside {
          background: #13131f !important;
          border-right: 1px solid rgba(255,255,255,.06);
          display: flex;
          flex-direction: column;
        }

        /* ── Logo alanı ── */
        .aside-logo {
          display: flex; align-items: center; justify-content: space-between;
          padding: 20px 20px 16px;
          border-bottom: 1px solid rgba(255,255,255,.06);
          flex-shrink: 0;
        }
        .aside-logo__brand {
          display: flex; align-items: center; gap: 10px;
          text-decoration: none;
        }
        .aside-logo__img { width: 32px; height: 32px; border-radius: 8px; object-fit: contain; }
        .aside-logo__name {
          font-size: 17px; font-weight: 700; letter-spacing: -.02em;
          color: #fff;
        }
        .aside-toggle-btn {
          width: 28px; height: 28px; border-radius: 8px; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          background: rgba(255,255,255,.06); color: rgba(255,255,255,.4);
          transition: background .15s, color .15s;
        }
        .aside-toggle-btn:hover { background: rgba(255,255,255,.1); color: #fff; }

        /* ── Menü scroll alanı ── */
        #kt_aside_menu_wrapper {
          flex: 1;
          overflow-y: auto;
          padding: 12px 12px 24px;
          scrollbar-width: thin;
          scrollbar-color: rgba(255,255,255,.1) transparent;
        }
        #kt_aside_menu_wrapper::-webkit-scrollbar { width: 4px; }
        #kt_aside_menu_wrapper::-webkit-scrollbar-track { background: transparent; }
        #kt_aside_menu_wrapper::-webkit-scrollbar-thumb {
          background: rgba(255,255,255,.1); border-radius: 2px;
        }

        /* ══ Menu Item ortak stilleri ══ */

        .ami-item { margin-bottom: 2px; }

        .ami-link {
          display: flex; align-items: center; gap: 10px;
          padding: 9px 12px; border-radius: 9px;
          text-decoration: none; position: relative;
          transition: background .15s, color .15s;
          color: rgba(255,255,255,.5);
        }
        .ami-link:hover {
          background: rgba(255,255,255,.06);
          color: rgba(255,255,255,.9);
        }
        .ami-link:hover .ami-icon { color: var(--theme-primary, #009ef7); }

        /* Aktif link */
        .ami-link--active {
          background: rgba(var(--theme-primary-rgb, 0,158,247), .12) !important;
          color: #fff !important;
        }
        .ami-link--active .ami-icon {
          color: var(--theme-primary, #009ef7) !important;
        }
        .ami-link--active .ami-title { font-weight: 600; }

        /* Sol aktif çizgi */
        .ami-active-bar {
          position: absolute; left: 0; top: 20%; bottom: 20%;
          width: 3px; border-radius: 0 3px 3px 0;
          background: var(--theme-primary, #009ef7);
        }

        /* Disabled */
        .ami-link--disabled {
          opacity: .35;
          pointer-events: none;
        }

        /* İkon */
        .ami-icon {
          width: 20px; flex-shrink: 0; display: flex;
          align-items: center; justify-content: center;
          color: rgba(255,255,255,.35);
          transition: color .15s;
        }

        /* Başlık */
        .ami-title {
          font-size: 13px; font-weight: 500; flex: 1;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          letter-spacing: -.01em;
        }

        /* Bullet (hasBullet için) */
        .ami-bullet {
          width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;
          background: rgba(255,255,255,.2);
          margin-left: 4px;
        }
        .ami-link--active .ami-bullet { background: var(--theme-primary, #009ef7); }

        /* ══ Sub menü ══ */

        .amis-item { margin-bottom: 2px; }

        .amis-trigger {
          cursor: pointer; user-select: none;
        }

        /* Ok ikonu */
        .amis-arrow {
          color: rgba(255,255,255,.2); flex-shrink: 0;
          transition: transform .2s, color .15s;
          display: flex; align-items: center;
        }
        .amis-arrow--open { transform: rotate(180deg); color: rgba(255,255,255,.5); }
        .ami-link:hover .amis-arrow { color: rgba(255,255,255,.5); }

        /* Disabled parent */
        .amis-item--disabled > .ami-link {
          opacity: .35; pointer-events: none;
        }

        /* Alt menü container */
        .amis-sub {
          display: none;
          padding-left: 14px;
          margin-top: 2px;
        }
        .amis-sub--open { display: block; }

        /* Alt menü items — bullet yerine ince sol çizgi */
        .amis-sub .ami-item { position: relative; }
        .amis-sub .ami-item::before {
          content: '';
          position: absolute; left: 10px; top: 0; bottom: 0;
          width: 1px;
          background: rgba(255,255,255,.07);
        }
        .amis-sub .ami-link {
          padding: 7px 10px 7px 28px;
          font-size: 12px; color: rgba(255,255,255,.4);
        }
        .amis-sub .ami-link:hover { color: rgba(255,255,255,.8); }
        .amis-sub .ami-link--active { color: #fff !important; }
        .amis-sub .ami-icon { width: 16px; }
        .amis-sub .ami-title { font-size: 12px; }

        /* ── Mobil overlay drawer ── */
        @media (max-width: 991px) {
          #kt_aside { width: 260px !important; }
        }
      `}</style>

      <div
        id='kt_aside'
        className='aside'
        data-kt-drawer='true'
        data-kt-drawer-name='aside'
        data-kt-drawer-activate='{default: true, lg: false}'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'260px', '300px': '260px'}"
        data-kt-drawer-direction='start'
        data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      >
        {/* ── Logo ── */}
        <div className='aside-logo' id='kt_aside_logo'>
          <Link to='/home' className='aside-logo__brand'>
            <img
              alt='Logo'
              className='aside-logo__img'
              src={toAbsoluteUrl('/media/logos/netway.png')}
            />
            <span className='aside-logo__name'>Wisnet</span>
          </Link>

          <button
            id='kt_aside_toggle'
            className='aside-toggle-btn'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
            title='Menüyü küçült'
          >
            <KTSVG
              path='/media/icons/duotune/arrows/arr080.svg'
              className='svg-icon-4'
            />
          </button>
        </div>

        {/* ── Menü ── */}
        <div className='aside-menu flex-column-fluid'>
          <AsideMenu asideMenuCSSClasses={[]} />
        </div>
      </div>
    </>
  )
}

export { AsideDefault }